'use client';

import { FC } from 'react';
import { useTheme } from 'styled-components';
import { useShallow } from 'zustand/react/shallow';

import { FAQSection } from '../CmsFaq';
import { HowToParticipateSection } from '../CmsHowToParticipate';
import { CmsPageDescription } from '../CmsPageDescription';
import { Wheel } from './components/Wheel';
import { FortuneWheelApi } from '@/api/cms';
import { ImageComponent } from '@/components/Image';
import { ClockUTC } from '@/modules/promotions/components/ClockUTC';
import { useCommonStore } from '@/store/commonStore';

import {
  ScWheelContent,
  ScWheelHeader,
  ScWheelHeaderAssets,
  ScWheelPage,
} from './styled';
import { ScContainer, Spinner } from '@/styles/common';

interface FortuneWheelPageProps {
  data: FortuneWheelApi;
}

const FortuneWheelPage: FC<FortuneWheelPageProps> = ({ data }) => {
  const { wheelLootboxes, isAuthenticated, isMobileDevice } = useCommonStore(
    useShallow((state) => ({
      wheelLootboxes: state.wheelLootboxes,
      isAuthenticated: state.isAuthenticated,
      isMobileDevice: state.isMobileDevice,
    }))
  );
  const { blackColor, mainColor } = useTheme();

  return (
    <ScWheelPage>
      {wheelLootboxes ? (
        <>
          <ScWheelHeader>
            <div className="content">
              <ScContainer>
                <h1>{data.pageTitle}</h1>
                <CmsPageDescription
                  className="description"
                  sections={data.description}
                />

                {/* temporary not used */}
                {/* {isAuthenticated && <SpinsCounter />} */}
              </ScContainer>
            </div>

            <Wheel
              lootboxes={wheelLootboxes}
              arrowImg={data.wheelArrow.url}
              bonusBuyPromocode={data.bonusBuyPromocode}
              wheelImages={data.wheel}
            />

            <div className="time-clock">
              <ClockUTC />
            </div>

            <ScWheelHeaderAssets>
              <ImageComponent
                className="bg"
                src={data.topBg.url}
                alt="background"
                fill
              />

              <ImageComponent
                className="decor left"
                width={260}
                height={260}
                src={data.leftDecor.url}
                alt="left decor"
              />

              {isMobileDevice && !isAuthenticated ? null : (
                <ImageComponent
                  className="decor right"
                  width={164}
                  height={164}
                  src={data.rightDecor.url}
                  alt="right decor"
                />
              )}

              {isMobileDevice ? (
                <ImageComponent
                  className="static mobile"
                  width={320}
                  height={228}
                  src={data.mobileCharacter.url}
                  alt="mobile character"
                />
              ) : (
                <>
                  <ImageComponent
                    className="static left"
                    width={320}
                    height={448}
                    src={data.leftCharacter.url}
                    alt="left character"
                  />
                  <ImageComponent
                    className="static right"
                    width={320}
                    height={448}
                    src={data.rightCharacter.url}
                    alt="right character"
                  />
                </>
              )}
            </ScWheelHeaderAssets>
          </ScWheelHeader>

          <ScContainer>
            <ScWheelContent>
              <HowToParticipateSection
                title={data.howToParticipateTitle}
                sections={data.howToParticipate}
              />
              <FAQSection sections={data.faq} />
            </ScWheelContent>
          </ScContainer>
        </>
      ) : (
        <Spinner size={50} color={mainColor} background={blackColor} />
      )}
    </ScWheelPage>
  );
};

export default FortuneWheelPage;
